<template>
    <v-card class=" card my-3 ml-5 pa-0">
        <v-container class="container">
            <v-card-text class="pa-2">
                <div class="row justify-end mb-2">
                    <v-chip
                        label
                        outlined
                        small
                        :color="statusColor()"
                        class="mb-1 mr-3 justify-end"
                    >
                        <h4>{{ cardStatus() }}</h4>
                    </v-chip>
                </div>
                <h2> {{ getPayment()}} </h2>
                <v-row >
                    <v-col>
                        <h4>Venc: {{payment_expiration}}</h4>
                    </v-col>
                    <v-col>
                        <h4>CVV: {{ payment_cvv}}</h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <h4>Valor: {{payment_amount}}</h4>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        v-if="payment_status !== 'canceled'"
                        class="py-0"
                    >
                        <v-btn
                            class="mt-4"
                            color="#FF3D00"
                            x-small
                            dark
                            @click="cancelCardDialog = true"
                        >
                            Cancelar cartão
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-img
                            class="img"
                            src="/images/LogoPayment.png">
                        </v-img>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-container>
        <v-dialog
            v-model="cancelCardDialog"
            persistent
            max-width="440"
        >
            <v-card>
                <v-card-title class="headline">
                    Cancelar o cartão?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darken-1"
                        text
                        @click="cancelCardDialog = false"
                    >
                        voltar
                    </v-btn>
                    <v-btn
                        color="error"
                        :loading='cancelCardLoading'
                        @click="cancelCard()"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
export default {
    name: "PaymentCard",
    props: {
        booking_id: Number,
        payment_card_number: String,
        payment_cvv: String,
        payment_expiration: String,
        payment_amount: String,
        payment_status: String,
    },
    data: () => ({
        cancelCardDialog: false,
        cancelCardLoading: false,
    }),
    methods:{
        getPayment() {
            return `${this.payment_card_number.substring(0, 4)}` + " " + `${this.payment_card_number.substring(4, 8)}` + " " +
                `${this.payment_card_number.substring(8, 12)}` + " " +
                `${this.payment_card_number.substring(12, 16)} `
        },
        cancelCard() {
            this.cancelCardLoading = true;
            axios.post('/api/card/cancel', {id: this.booking_id})
                .then(res => {
                    if (res.data.success) {
                        this.$forceUpdate();
                        window.location.reload();
                    }
                    this.cancelCardLoading = false;
                    this.cancelCardDialog = false;
                }).catch(() => {
                window.confirm('Algo deu errado, tente novamente mais tarde');
                this.cancelCardLoading = false;
                this.cancelCardDialog = false;
            });
        },
        cardStatus() {
            const status = {
                blocked: 'Bloqueado',
                active: 'Desbloqueado',
                canceled: 'Cancelado',
            }
            return status[this.payment_status];
        },
        statusColor() {
            const color = {
                blocked: 'warning',
                active: 'success',
                canceled: 'error',
            }
            return color[this.payment_status];
        }
    }
}
</script>

<style lang="scss" scoped>
.card{
    background: #F5F5F5 ;
    height: 200px;
    width: 370px;
    border-radius: 16px;
    color: #000000;
    position: relative;
}

.img{
    width: 40%;
    margin-left: 55%;
    position: absolute;
    bottom: 20px;
    right: 20px;
}
</style>
